import { cn } from '@/lib/utils';

/** Google's own Sheets and Docs product icons (public/logos), for the
 * surfaces that connect to or open those products. */
export function GoogleSheetsIcon({ className }: { className?: string }) {
  return (
    <img
      src='/logos/google-sheets.svg'
      alt=''
      aria-hidden
      className={cn('shrink-0 object-contain', className)}
    />
  );
}

export function GoogleDocsIcon({ className }: { className?: string }) {
  return (
    <img
      src='/logos/google-docs.svg'
      alt=''
      aria-hidden
      className={cn('shrink-0 object-contain', className)}
    />
  );
}
